export const COLORS = {
  border: '#e6e8ec',
  borderStrong: '#d6d9df',
  textPrimary: '#101828',
  textSecondary: '#667085',
  textMuted: '#98a2b3',
  accent: '#3B82F6',
  accentBg: '#EFF6FF',
  success: '#16A34A',
  err: '#DC2626',
  warn: '#D97706',
  unusual: '#F1C40F',
  info: '#0284C7',
  bp: '#0F766E',
  bpBg: '#F0FDFA',
  rt: '#C2410C',
  rtBg: '#FFF7ED',
  sim: '#4338CA',
  simBg: '#EEF2FF',
};

export const SEV = {
  Error: { color: COLORS.err, symbol: '!' },
  Warning: { color: COLORS.warn, symbol: '!' },
  Unusual: { color: COLORS.unusual, symbol: '?' },
  Info: { color: COLORS.info, symbol: 'i' },
};

export const SRC = {
  'Blueprint Validator': { color: COLORS.bp, bg: COLORS.bpBg },
  Runtime: { color: COLORS.rt, bg: COLORS.rtBg },
  Simulation: { color: COLORS.sim, bg: COLORS.simBg },
};

export const DEBUG_LEVELS = [
  {
    title: "Critical",
    value: "critical",
    description: "Critical issues requiring immediate attention"
  },
  {
    title: "Unusual",
    value: "unusual",
    description: "Unusual events or unexpected behavior"
  },
  {
    title: "Debug Low",
    value: "debugl",
    description: "Low-detail debugging information"
  },
  {
    title: "Debug Medium",
    value: "debugm",
    description: "Moderate-detail debugging information"
  },
  {
    title: "Debug High",
    value: "debug",
    description: "Detailed debugging information"
  }
];

export const SIM_RUNS = [
  { value: '884', label: 'Run #884 (latest)' },
  { value: '883', label: 'Run #883' },
  { value: '882', label: 'Run #882' },
  { value: 'all', label: 'All runs' },
];

export function fmtTime(minutesAgo) {
  const d = new Date(Date.now() - minutesAgo * 60000);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export const LEVEL_STYLES = {
  trace: { color: COLORS.textMuted, symbol: 'i' },
  debug: { color: COLORS.unusual, symbol: 'i' },
  unusual: { color: COLORS.unusual, symbol: 'i' },
  info: { color: COLORS.info, symbol: 'i' },
  warn: { color: COLORS.warn, symbol: '!' },
  warning: { color: COLORS.warn, symbol: '!' },
  error: { color: COLORS.err, symbol: '!' },
  fatal: { color: COLORS.err, symbol: '!' },
  success: { color: COLORS.success, symbol: '✓' },
};

export function getLevelStyle(level) {
  const key = String(level || '').toLowerCase();
  return LEVEL_STYLES[key] || { color: COLORS.textSecondary, symbol: '•' };
}


export function formatLogTime(ts, isUtc = false) {
  if (!ts) return '—';

  const original = String(ts);

  // Extract fractional seconds from the original timestamp
  const fractionMatch = original.match(/\.(\d+)/);
  const fraction = fractionMatch
    ? fractionMatch[1].padEnd(6, '0').slice(0, 6)
    : '000000';

  // Keep only milliseconds for JavaScript Date parsing
  const trimmed = original.replace(/(\.\d{3})\d*/, '$1');

  const hasOffset = /[zZ]|[+-]\d{2}:?\d{2}$/.test(trimmed);
  const normalized = isUtc && !hasOffset ? `${trimmed}Z` : trimmed;

  const d = new Date(normalized);

  if (isNaN(d.getTime())) return String(ts);

  const datePart = d.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  return `${datePart}.${fraction}`;
}

export function extractText(node) {
  if (node === null || node === undefined || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(extractText).join(' ');
  if (node.props && node.props.children !== undefined) return extractText(node.props.children);
  return '';
}